import { useQuery } from '@tanstack/react-query';
import { billingService } from '@/services';
import { queryKeys } from '@/services/query-keys';
import type { AccrualEntry } from '@/types';

/**
 * Per-tab read hook that fetches the COMPLETE accrual series for a position.
 *
 * Wraps billingService.getAllAccrualsForPosition (page-complete, not capped at
 * the PAGE_SIZE=100 default) so the accrued-income hero (ANLY-01) cannot be
 * undercounted on a long-lived position. Mirrors the use-trade-transactions
 * read-hook idiom.
 */
export const useTradeAccruals = (id: number, enabled: boolean = true) => {
  return useQuery<AccrualEntry[]>({
    queryKey: queryKeys.billing.accrualList({ position_id: String(id) }),
    queryFn: () => billingService.getAllAccrualsForPosition(id),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    enabled: enabled && id > 0,
  });
};
